








import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import { OPTHINES } from './config';
import { Button, Toast } from 'vant';
Vue.use(Button);
@Component({
  components: {
    VoteList,
  },
})
export default class List extends Vue {
  option = OPTHINES;
  voteId: string = '';
  typeTitle = '重庆100佳民心医师';
  get type() {
    return this.$route.query.type;
  }
  created() {
    if (Number(this.$route.query.type) === 1) {
      this.typeTitle = '重庆100佳民心科室';
    }
    this.$appShareInfo({
      title: '健康民心“双百”口碑榜',
      url: window.location.href,
      subtitle: '第三届医师节千万网民点赞的“100佳民心医师和100佳民心科室”活动',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });

    this.$wxShareInfo({
      title: '健康民心“双百”口碑榜',
      subtitle: '第三届医师节千万网民点赞的“100佳民心医师和100佳民心科室”活动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
